import { render, staticRenderFns } from "./Die_Capabilities.vue?vue&type=template&id=73f3fa84&scoped=true"
import script from "./Die_Capabilities.vue?vue&type=script&lang=js"
export * from "./Die_Capabilities.vue?vue&type=script&lang=js"
import style0 from "./Die_Capabilities.vue?vue&type=style&index=0&id=73f3fa84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f3fa84",
  null
  
)

export default component.exports